{
  "Stock": {
    "visible": [1, "kit"],
    "editable": [1]
  },
  "Quotas": {
    "visible": [1, 2, 5, 7],
    "editable": [1, 2, 5, 7]
  },
  "AllowComments": {
    "visible": [2, 5, 7],
    "editable": [2, 5, 7]
  },
  "Validation": {
    "visible": [1, 2, 5, 7],
    "editable": [1, 2, 5, 7]
  },
  "OrderAttachments": {
    "visible": [1, 2, 5, 7],
    "editable": [1, 2, 5, 7]
  },
  "Tracking": {
    "visible": [1],
    "editable": [1]
  },
  "Contact": {
    "visible": [1, 2, 5, 7],
    "editable": [1, 2, 5, 7]
  },
  "DuplicateOrderAlert": {
    "visible": [1, 2, 5, 7],
    "editable": [1, 2, 5, 7]
  },
  "DateFilling": {
    "visible": [5],
    "editable": [5]
  },
  "Unity": {
    "visible": [2],
    "editable": [2]
  },
  "EventProductTreeLevel": {
    "visible": [2],
    "editable": [2]
  },
  "PrestationHours": {
    "visible": [2],
    "editable": [2]
  },

  "Subdivision": {
    "visible": [5],
    "editable": [5]
  },
  "ProductTreeLevel": {
    "visible": [5],
    "editable": [5]
  },
  "Calculator": {
    "visible": [5],
    "editable": [5]
  },

  "SerialNumber": {
    "visible": [7],
    "editable": [7]
  },
  "RentProductTreeLevel": {
    "visible": [7],
    "editable": [7]
  },
  "RateProduct": {
    "visible": [7],
    "editable": [7]
  },
  "RatePeriod": {
    "visible": [7],
    "editable": [7]
  },
  "RateTransportDelivery": {
    "visible": [7],
    "editable": [7]
  },
  "RateTransportRecovery": {
    "visible": [7],
    "editable": [7]
  },
  "EarlyOrExpandRequest": {
    "visible": [7],
    "editable": [7]
  },
  "EnableLongDuration": {
    "visible": [7],
    "editable": [7]
  },
  "CouplingRentType": {
    "visible": [7],
    "editable": [7]
  },
  "EnableTranfert": {
    "visible": [7],
    "editable": [7]
  },
  "ForceGroupingRequestEndDate": {
    "visible": [7],
    "editable": [7]
  },
  "Evaluation": {
    "visible": [2, 5, 7],
    "editable": [2, 5, 7]
  },
  "Constat": {
    "visible": [2, 5, 7],
    "editable": [2, 5, 7]
  },
  "GEOLOC": {
    "visible": [10],
    "editable": [10]
  },
  "MAIN_KPI_1": {
    "visible": [10],
    "editable": [10]
  },
  "MAIN_KPI_2": {
    "visible": [10],
    "editable": [10]
  },
  "MAIN_KPI_3": {
    "visible": [10],
    "editable": [10]
  },
  "SALESFORCE": {
    "visible": [10],
    "editable": [10]
  },
  "ValidationSegmentationDL": {
    "visible": [10],
    "editable": [10]
  },
  "PromoPlanningFilter": {
    "visible": [10],
    "editable": [10]
  },
  "Legislation": {
    "visible": [10],
    "editable": [10]
  },
  "OnlyOneCurrentVisit": {
    "visible": [10],
    "editable": [10]
  },
  "Routing": {
    "visible": [10],
    "editable": [10]
  },
  "VisitCounter": {
    "visible": [10],
    "editable": [10]
  },
  "ValidationTypeDL": {
    "visible": [10],
    "editable": [10]
  },
  "EnableReferencePdtOutToPicking": {
    "visible": [10],
    "editable": [10]
  },
  "PromoValueToUse": {
    "visible": [10],
    "editable": [10]
  },
  "MerchTourPlan": {
    "visible": [5],
    "editable": [5]
  },
  "PreOrder": {
    "visible": [1, 2, 5, 7],
    "editable": [1, 2, 5, 7]
  }
}
